<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="unreadNotifications.length" />

    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

      <div class="notification-top text-center p-5 bg-primary text-white">
        <h3 class="text-white">{{ unreadNotifications.length }} New</h3>
        <p class="opacity-75" v-text="$t('user_notifications')"></p>
      </div>

      <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings" :key="$vs.rtl">
        <ul class="bordered-items">
          <li
            v-for="(ntf, key) in unreadNotifications"
            :key="key"
            class="flex justify-between px-4 py-4 notification cursor-pointer"
            @click.prevent="ntf.type === 'announcement' ? viewAnnouncementPopup(ntf.id) : ntf.type === 'schedule' ? viewSchedulePopup(ntf.id) : viewTaskPopup(ntf.id)">
            <div class="flex items-start">
              <feather-icon :icon="ntf.type === 'announcement' || ntf.type === 'schedule' ? 'MessageCircleIcon' : 'Edit3Icon'" :svgClasses="[ntf.type === 'announcement' || ntf.type === 'schedule' ? `text-primary` : `text-warning`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>

              <div class="mx-2">
                <span class="font-medium block notification-title" :class="[ntf.type === 'announcement' || ntf.type === 'schedule' ? `text-primary` : `text-warning`]" v-text="$stringHelper.limitString(ntf.title, 20)"></span>
                <!-- /.<small>{{ ntf.msg }}</small> -->
              </div>
            </div>
            <small class="mt-1 whitespace-no-wrap" v-if="ntf.type === 'announcement'" v-text="$momentHelper.getTimeAgo(ntf.notification_date, language)"></small>
          </li>
        </ul>
      </component>

      <div class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        text-primary
        w-full
        p-2
        font-semibold
        text-center
        border
        border-b-0
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light
        cursor-pointer">
        <!-- /.<span>View All Notifications</span> --> <!-- /.TODO: Add Notifications page to show all, Limit Notification here on dropdown. -->
      </div>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Notification from '@/models/Notification'
import { EventBus } from '@/../eventbus'
import announcementSocket from '@/libs/sockets/announcements'
import Utils from '@/helpers/utils'

export default {
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      unreadNotifications: [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag },

    servers () { return this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.servers : {} },
    language () { return this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.language : 'en' }
  },
  mounted () {
    this.loadNotifications()
    EventBus.$on('loadNotifications', () => {
      this.loadNotifications()
    })

    // Initialize Socket IO
    if (!this.$store.getters.isAdmin) {
      announcementSocket.setNode(this.servers)
      announcementSocket.getSocket().on('new_announcement', () => {
        this.loadNotifications()
      })
    }
  },
  methods: {
    async loadNotifications () {
      const response = await Notification.getNotification({ unseenAnnouncement: true })
      this.unreadNotifications = response.data
      let hasSchedules = false
      this.unreadNotifications.forEach((data) => {
        if (data.type === 'schedule') {
          this.viewSchedulePopup(data.id)
          hasSchedules = true
        }
      })
      if (hasSchedules === true) {
        setTimeout(function () {
          EventBus.$emit('loadNotifications')
        }, 3000)
      }
    },
    announcementModal (data) {
      EventBus.$emit('initAnnouncementViewData', data)
      $('#viewAnnouncementModal').modal('show')
    },
    async viewAnnouncementPopup (id) {
      Utils.openPopUp('window', 'view-announcement', { id }, this.announcementModal) // this.$store.getters.ctiPopUp TODO: Global Modal?
      await Notification.notify({ id, type: 'announcement' }) // TODO: handle const response =
      EventBus.$emit('loadNotifications')
    },
    taskModal (data) {
      EventBus.$emit('initViewTaskModal', data)
      $('#viewTaskModal').modal('show')
    },
    async viewTaskPopup (id) {
      Utils.openPopUp('window', 'view-task', { id }, this.taskModal) // this.$store.getters.ctiPopUp TODO: Global Modal?
      await Notification.notify({ id, type: 'task' }) // TODO: handle const response =
      EventBus.$emit('loadNotifications')
    },
    async viewSchedulePopup (id) {
      Utils.openPopUp('window', 'view-schedule', { id }) // this.$store.getters.ctiPopUp TODO: Global Modal?
      await Notification.notify({ id, type: 'schedule' }) // TODO: handle const response =
    }
  }
}

</script>

